import React, {Component} from 'react';
import SearchingTitleComponent from './SearchingTitleComponent';
import ReactDOM from 'react-dom';
import { Button, Col, Row, Modal, ModalFooter, ModalBody, ModalHeader,  } from 'reactstrap';
import { AddFileAttempt_ACTION, GeMap_SPECIAL_ACTION, UpdateMap_LS_ACTION } from '../Actions/LogisticActions';
import {connect} from 'react-redux'
import { Routes } from '../Services/API';
import NameComponent from './NameComponent';
import { FixURL, responsiveFontSize, responsiveHeight, responsiveWidth, WEBSITE_URL } from '../Services/Utilities';
import QuestionSeriesPlayinMap from '../views/Questions/QuestionSeriesPlayinMap';
import Xarrow from "react-xarrows";
import Slider from '@material-ui/core/Slider';
import { requirePropFactory } from '@material-ui/core';

var PDF_BTN = require('../Sources/Buttons_PDF button.png')
var VIDEO_BTN = require('../Sources/Button_Video.png')
var MAP_BTN = require('../Sources/Buttons_Video button.png')
var LINK_BTN = require('../Sources/Buttons_Link button.png')
var SERIES_BTN = require('../Sources/Buttons_Question Series button.png')
var FinalElementImage = require('../Sources/goal-icon.png')


class PlayGeneralMap extends Component {
    constructor(props){
        super(props)

        this.divRef = React.createRef()

        this.state = {
            baseWidth:0,
            imageWidths: [
                0
            ],
            zoomInOutShow: false,
            zoomValue:100,

            imageWidthsIndex:0
        }


        this.ElementModal = this.ElementModal.bind(this)
        this.calculateImageWidth = this.calculateImageWidth.bind(this)
        this.HideModals = this.HideModals.bind(this)

        this.renderSolutionPath = this.renderSolutionPath.bind(this)
        this.renderMapElement = this.renderMapElement.bind(this)
        this.renderBadge = this.renderBadge.bind(this)

        this.HandleElementClick = this.HandleElementClick.bind(this)
        this.checkElementRelationSatisfied = this.checkElementRelationSatisfied.bind(this)
    }

    componentDidMount(){
        this.props.GetMap(this.props.Id)
    }

    
    render(){
        let {baseWidth, zoomValue, zoomInOutShow} = this.state
        const imageWidth = baseWidth * (zoomValue/100)
        return(
            <div 
                ref = {this.divRef}
            >
                {this.ElementModal()}
               {(this.props.IsSearching  || this.props.IsSearching == undefined || this.props.GetError || this.props.GetError == undefined) ? 
                      <SearchingTitleComponent error = {this.props.GetError}/>
                  :
                  (!this.state.PlaySeries ? 
                    <div >
                        {/*<div >
                           <div style = {{margin: responsiveFontSize(0.125)}}>
                           <h6 
                            className="text-muted" 
                            style = {{cursor:'pointer'}}
                            onClick = {() => {
                                this.setState({
                                    zoomInOutShow: !zoomInOutShow
                                })
                            }}
                            >Zoom in/out</h6>

                        
                        {zoomInOutShow ? 
                        <div style = {{width: responsiveWidth(20)}}>
                      
                        <Slider
                        size="small"
                        defaultValue={zoomValue}
                        max = {100}
                        min = {20}
                        aria-label="Small"
                        valueLabelDisplay="auto"
                        onChange = {(v, nv) => {
                           this.setState({
                               zoomValue: nv
                           })
                        }}
                        marks = {
                            [{
                            value: 22,
                            label: '20%',
                            },
                            {
                                value: 100,
                                label: '100%',
                            }]}
                        />
                        </div> : <div/>}
                           </div>
                        </div>*/}
                    <div style = {{flexDirection:'row', display:'flex', alignContent:'flex-start', alignItems:'flex-start'}}>
                        <div
                        className="border border rounded bg bg-light"
                        style = {{cursor:'pointer'}}
                        onClick = {() => {
                            let zoomValue = this.state.zoomValue
                            zoomValue += 10

                            zoomValue = Math.min(100, Math.max(20, zoomValue))

                            this.setState({
                                zoomValue: zoomValue
                            })
                        }}
                        >
                            <h6 
                            className="text-success"
                            style = {{fontSize: responsiveFontSize(1.0), margin: responsiveFontSize(0.1),
                             marginLeft: responsiveWidth(0.25), marginRight: responsiveWidth(0.25), textAlign:'center'}}>
                                +
                            </h6>
                        </div>
                        <div
                        className="border border rounded bg bg-light"
                        style = {{marginLeft:'0.25%', cursor:'pointer'}}
                        onClick = {() => {
                            let zoomValue = this.state.zoomValue
                            zoomValue -= 10

                            zoomValue = Math.min(100, Math.max(20, zoomValue))

                            this.setState({
                                zoomValue: zoomValue
                            })
                        }}
                        >
                            <h6 
                            className="text-danger"
                            style = {{fontSize: responsiveFontSize(1), margin: responsiveFontSize(0.1),
                             marginLeft: responsiveWidth(0.4), marginRight: responsiveWidth(0.4), textAlign:'center'}}>
                                -
                            </h6>
                        </div>
                       
                    </div>
                  <Row
                  >
                  <Col xs = {12}>
                      <div>
                      <img 
                        src = {this.props.Map.LargeMapURL}
                        style = {{width: imageWidth, height: (this.props.Map.LargeMapLength/this.props.Map.LargeMapWidth) * imageWidth}}
                        ref = {'Image_Div'}
                        onLoad = {() => {
                            let node = ReactDOM.findDOMNode(this.refs['Image_Div']).parentNode.parentNode
                            let nodeStyle = window.getComputedStyle(node)
                            let padding = nodeStyle.getPropertyValue('padding')
                            let Offset = parseInt(padding.substring(4,6))

                            this.setState ({
                                Offset:Offset,
                            })
                          

                            //this.calculateImageWidth()

                            setTimeout(() => {
                                this.calculateImageWidth()

                            }, 200)
                        }}
                      
                      />
                    
                    {this.props.Map.Elements.map((e,i) => this.renderMapElement(i,e))}
                    
                    {this.props.Map.Elements.filter(e => (e.Badge_X && e.Badge_Y)).map((e,i) => this.renderBadge(i, e))}

                    {this.props.ShowSolutionPath ? this.renderSolutionPath() : <div/>} 

                </div>
                </Col>
                
              </Row>
              </div>: 
                <QuestionSeriesPlayinMap 
                          Code = {this.state.SelectedElement.QuestionSeries.Code}
                          Object = {this}
                          ObjectId = {this.props.Map.Id}
                          Map = {this.props.Map}
                          Key = {this.props.MapKey}
                          ElementId={this.state.SelectedElement.Id}
                          Element={this.state.SelectedElement}
                />)}
            </div>
        )
    }

    calculateImageWidth(){
        var containerDiv =  this.divRef.current
        let baseWidth = containerDiv.children[0].childNodes[0].clientWidth
        const fullSizeWidth =  baseWidth*0.95


        let widthsArray = []
        widthsArray.push(fullSizeWidth)

        for(let i =1; i<9;i++){
            widthsArray.push((1-0.1*i)*fullSizeWidth)
        }

        this.setState ({
            baseWidth: baseWidth,
            imageWidths: widthsArray
        })
    }

    HideModals() {
        let modalKeys = Object.keys(this.state).filter((k) => k.includes("ShowModal"))
        let state = this.state
     
        for(let k of modalKeys){
          state[k] = false
        }
     
        this.setState({
          ...state
        })
      }

    ElementModal(){
        if(!this.state.ShowModal_Element){
            return
        }

        let Element = this.state.SelectedElement
        let RElement = this.state.SelectedElement.RequiredElement
        let RMElement = undefined 

        if(RElement){
            RMElement = this.props.Map.Elements.filter((e) => e.Id == RElement.Id)[0]
        }

        let playable = 
        ((!RElement || !RElement.QuestionSeries ||
            (RMElement.LS_Answer 
                && 
            
            (Element.Threshold 
            < 
            100 * RMElement.QuestionSeries.Elements.filter((eL) => RMElement.LS_Answer.Progress.map(p => p.Id).includes((eL.QuestionId))).length/(RMElement.QuestionSeries.IsRandom ? RMElement.QuestionSeries.RandomSize : RMElement.QuestionSeries.Elements.length))
           

            )))

        return(
            <Modal isOpen = {this.state.ShowModal_Element} size = "lg" NoActionLog = {true}>
            <ModalBody>
                <div
                className ="square border-bottom"
                style = {{flexDirection:'row', display:'flex', alignContent:'flex-start', alignItems:'flex-start', width:'100%', marginBottom: responsiveHeight(0.75)}}>
               <div style = {{width:'80%'}}>
                    <h6 className="text-primary" style = {{textAlign:'left',fontSize: responsiveFontSize(0.8), width:'100%', height:'100%'}}>
                        {this.state.SelectedElement.Title}
                    </h6>
                </div>
                <div style = {{width:'20%', flexDirection:'row-reverse', display:'flex',
                 alignContent:'flex-start', alignItems:'flex-start'}}>
                     
                    <div 
                    className="square border border-bottom-0"
                    onClick = {this.HideModals}
                    style = {{
                        cursor:'pointer',
                        flexDirection:'column', display:'flex', alignItems:'center', alignContent:'center',
                         width: responsiveWidth(1.5), height: responsiveWidth(1.5), backgroundColor:'#f2f2f2'}}>
                            <h6 
                            className="text-danger"
                            style = {{textAlign:'center',fontSize: responsiveFontSize(0.8),
                                  width:'100%', margin: responsiveFontSize(0.25), height:'100%'}}>
                                    X
                            </h6>
                    </div>
                </div>
                
                </div>
            {playable ?
            <div>
            {this.renderElementInModal(this.state.SelectedElement)}

            </div> : this.pleaseGoToElement(RElement,RMElement, Element)}   
            </ModalBody>
            
                     
            </Modal>
        )
    }

    renderElementInModal(e){
        return(
        <div style = {{flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center'}}>


            {e.QuestionSeries ? this.renderElementBox(e, () => {
                this.setState({
                    PlaySeries: true,
                    ShowModal_Element: false
                })
            }, 'Play', SERIES_BTN) : <div/>}

            {e.ExternalVideoLink ? this.renderElementBox(e, () => window.open(e.ExternalVideoLink), 'Link', LINK_BTN) : <div/>}

            {e.PDFURL ? this.renderElementBox(e, () => {
                 window.open(e.PDFURL)

                 let data = new FormData()
                 data.append('ElementId', this.state.SelectedElement.Id)
                 data.append('Player', this.props.Player)
 
                 this.props.PostPDFStatistic(data)
            }, 'PDF', PDF_BTN) : <div/>}

            {e.VideoURL ? this.renderElementBox(e, () => window.open(e.VideoURL), 'Video', VIDEO_BTN) : <div/>}

        </div>)
    }
    
    renderElementBox(e, action, imageAccess, alertnativeImage){
        return(
            <div
            style = {{marginRight: responsiveWidth(1),
                    flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', 
                    cursor:'pointer'
            }}
            onClick = {() => action()}>
            <img  
                src = {e.CourseMapElementImages && e.CourseMapElementImages[imageAccess] ? e.CourseMapElementImages[imageAccess] : alertnativeImage}
                style = {{
                    width: responsiveWidth(8),
                    height: responsiveWidth(8)
                }}
            />
            </div>
        )
    }

    pleaseGoToElement(RElement,RMElement, Element){
        

        return(
            <div  
            className = "border"
            onClick = {() =>this.setState({SelectedElement: RMElement})}
            style = {{cursor:'pointer', flexDirection:'column',
            display:'flex', alignContent:'center', alignItems:'center',
            }}
            >
                <div style = {{margin: responsiveFontSize(0.25), height:'100%', marginBottom: responsiveHeight(4),marginTop: responsiveHeight(4)}}>
                    <h6 style = {{fontSize: responsiveFontSize(1.0), width:'100%', textAlign:'center'}}>
                    Please solve question series in element <strong className="text-primary">{RElement.Title}</strong> up to <strong className="text-primary">{Element.Threshold}% </strong> success
                    </h6>
                    <h6
                    className="text-muted"
                    style = {{fontSize: responsiveFontSize(0.8), width:'100%', textAlign:'center'}}>
                        <i>Click to go to this element</i>
                    </h6>
                </div>
            </div>
        )
    }

    renderMapElement(key, e){

        return(
            <span
            key = {key}          
            className={this.props.Map.ShowBorder ? "border border-primary" : ""}

            id = {"REF_ID_"+e.Title}

            style = {{
                cursor:'pointer',
                
                ...this.calculateElementDimensions(e),
                
                backgroundPosition:'center',
                backgroundRepeat:'no-repeat',
                backgroundSize:'cover',
                [e.BackgroundImage ? "backgroundImage" : ""]:  "url(" + FixURL(e.BackgroundImage) + ")",

             }}

             onClick = {() => this.HandleElementClick(e)}
            >
                {this.renderBadgeInElement(e)}
                {this.props.ShowSolutionPath && e.IsFinal  ? this.renderFinalElement() : <div/>}
            </span>
             
        )
    }

    renderBadge(key, e){
        let elementRendersBadge = e.Badges.length && e.QuestionSeries && this.props.Map.LS.DataExists

        if(!elementRendersBadge) return (<div/>);

        let elementBadge = this.getElementBadgeSatisfied(e)

        return(
            <span 
                className={this.props.Map.ShowBorder ? "border border-success" : ""} 
                key = {key}
                style = {{...this.calculateBadgeDimensions(e) }}
            >
                {elementBadge? 
                    <img 
                        src = {elementBadge.URL}
                        style = {{
                            width: '100%',
                            height:'100%'
                        }}
                    /> : <div/>}                       
                     </span>
        )
    }

    renderBadgeInElement(e){
        let elementRendersBadge =  !(e.Badge_X || e.Badge_Y) && e.Badges.length && e.QuestionSeries && this.props.Map.LS.DataExists

        if(!elementRendersBadge) return (<div/>);

        let elementBadge = this.getElementBadgeSatisfied(e)

        return(
            <span>
                {elementBadge? 
                    <img 
                        src = {elementBadge.URL}
                        style = {{
                            width:  responsiveWidth(2),
                            height: responsiveWidth(2)
                        }}
                    /> : <div/>}                       
        </span>
        )
    }

    HandleElementClick(e){
        let relationSatisfied = this.checkElementRelationSatisfied(e)

        if(relationSatisfied){
            let onlySeries = e.QuestionSeries && !e.PDFURL && !e.VideoURL && !e.ExternalVideoLink
            
            if(onlySeries){
                this.setState({
                    SelectedElement:e,
                    PlaySeries: true,
                    ShowModal_Element: false
                })
                return
            }

            let onlyPDF =  e.PDFURL && !e.QuestionSeries && !e.VideoURL && !e.ExternalVideoLink

            if(onlyPDF){
                window.open(e.PDFURL)
                return
            }

            let onlyVideo =  e.VideoURL && !e.QuestionSeries && !e.PDFURL && !e.ExternalVideoLink

            if(onlyVideo){
                window.open(e.VideoURL)
                return
            }

            let onlyLink =  e.ExternalVideoLink && !e.QuestionSeries && !e.PDFURL && !e.VideoURL

            if(onlyLink){
                window.open(e.ExternalVideoLink)
                return
            }
        }   

        this.setState({
            SelectedElement: e,
            ShowModal_Element: true
        })

    }

    calculateElementDimensions(e){
        let {baseWidth, zoomValue} = this.state
        const imageWidth = baseWidth * (zoomValue/100)
        return({
            position: 'absolute',

            width: e.Width*((imageWidth)/this.props.Map.LargeMapWidth),
            height: e.Length*(((this.props.Map.LargeMapLength/this.props.Map.LargeMapWidth) * imageWidth)/this.props.Map.LargeMapLength),
            left:  (e.X - this.state.Offset/2)*((imageWidth)/this.props.Map.LargeMapWidth),
            top:  (e.Y)*(((this.props.Map.LargeMapLength/this.props.Map.LargeMapWidth) * imageWidth)/this.props.Map.LargeMapLength),
           
        })
    }

    calculateBadgeDimensions(e){
        let {baseWidth, zoomValue} = this.state
        const imageWidth = baseWidth * (zoomValue/100)
        return({
            position: 'absolute',
            width: e.Badge_Width*((imageWidth)/this.props.Map.LargeMapWidth),
            height: e.Badge_Length*(((this.props.Map.LargeMapLength/this.props.Map.LargeMapWidth) * imageWidth)/this.props.Map.LargeMapLength),
            left:  (e.Badge_X - this.state.Offset/2)*((imageWidth)/this.props.Map.LargeMapWidth),
            top:  (e.Badge_Y)*(((this.props.Map.LargeMapLength/this.props.Map.LargeMapWidth) * imageWidth)/this.props.Map.LargeMapLength)
          })
    }

    checkElementRelationSatisfied(e){
        let Element = e
        let RElement = e.RequiredElement
        let RMElement = undefined 

        //Check if there is a required element 
        if(RElement){
            RMElement = this.props.Map.Elements.filter((e) => e.Id == RElement.Id)[0]

            // Required element has no question series
            if(!RMElement.QuestionSeries){
                return true
            }

            let numberOfQuestionsInSeries = 
            RMElement.QuestionSeries.IsRandom ?
            RMElement.QuestionSeries.RandomSize : RMElement.QuestionSeries.Elements.length

            // get saved previous student progress for this 
            let satisfied = RMElement.LS_Answer 

            // if there are no answers return false
            if(!satisfied) return false;

            //let progressSoFar = RMElement.QuestionSeries.Elements.filter((eL) => RMElement.LS_Answer.Progress.map(p => p.Id).includes((eL.QuestionId))).length

            let progressSoFar = RMElement.LS_Answer.Progress.filter(p =>RMElement.QuestionSeries.Elements.map(eL => eL.QuestionId).includes(p.Id))
            progressSoFar = progressSoFar.length

            satisfied = (Element.Threshold <=  100 * progressSoFar/(numberOfQuestionsInSeries))

            return satisfied // true or false
        }
        else{
            return true
        }

    }

   getElementBadgeSatisfied(e){
        let satisfied = e.LS_Answer

        if(!satisfied) return null;

        let numberOfQuestionsInSeries =
        e.QuestionSeries.IsRandom ?
        e.QuestionSeries.RandomSize : e.QuestionSeries.Elements.length
        let progress = e.LS_Answer.Progress.filter(p =>e.QuestionSeries.Elements.map(eL => eL.QuestionId).includes(p.Id))
        //let progress = e.QuestionSeries.Elements.filter((eL) => e.LS_Answer.Progress.map(p => p.Id).includes((eL.QuestionId))).length
        progress = progress.length
       
        for(let b of e.Badges.sort((ab, bb) => ab.Progress > bb.Progress ? -1 : 1)){
            console.log(b)
            satisfied = (b.Progress <= 100 * (progress/numberOfQuestionsInSeries))

            if(satisfied) return b;
        }

        return null;
    }

    renderFinalElement(){
        return(
            <div style = {{flexDirection:'column', display:'flex', alignItems:'center', alignContent:'center'}}>
                <img 
                    style = {{width: '100%',height: '100%'}}
                    src = {FinalElementImage}    
                /> 
            </div>
        )
    }

    renderSolutionPath(){
        return(
            this.props.Map.Elements
            .filter((e,i) => e.RequiredElement)
            .sort((a,b) => a.Id > b.Id ? 1 : -1)
            .map((e,i) => ( this.renderArrow(i, e)))
        )
    }

    renderArrow(key, element){
        return(
            <div 
            key = {key}
            >
            <Xarrow
                    start={'REF_ID_' + element.RequiredElement.Title} 
                    end={'REF_ID_' + element.Title} 
                    strokeWidth={2}
                    headSize={5}
                    startAnchor="auto"
                    endAnchor="auto"
                    color={"green"}
                    path={"straight"}
                />
            </div> 
        )
    }

    
}
//Constant

const COURSE_MAP_SEARCHING_PARAMETER = 'IsCourseMapSearching'
const COURSE_MAP_DATA_PARAMETER = 'CourseMap'
const COURSE_MAP_GET_ERROR_PARAMETER = 'CourseMapGetError'
//LOCAL STORAGE
export const LS_MAP = 'LS_MAP_12162020_'
function MapStateToProps(state) {
    return {
        IsSearching: state.Query[COURSE_MAP_SEARCHING_PARAMETER],
        Map: state.Query[COURSE_MAP_DATA_PARAMETER],
        GetError: state.Query[COURSE_MAP_GET_ERROR_PARAMETER],
        Name: state.Authorization.name,
        Player: state.Authorization.student_key,

    }
  }
  
  const MapDispatchToProps = (dispatch) => {
    return {
        GetMap: (Id) => {dispatch(GeMap_SPECIAL_ACTION({
            SearchParameter: COURSE_MAP_SEARCHING_PARAMETER,
            DataParameter: COURSE_MAP_DATA_PARAMETER,
            GetErrorParameter: COURSE_MAP_GET_ERROR_PARAMETER,
            Path: Routes.GetCourseMapPlayById,
            Value: Id,
    
            [COURSE_MAP_SEARCHING_PARAMETER]: true,
            
            [COURSE_MAP_DATA_PARAMETER]: [],
    
            [COURSE_MAP_GET_ERROR_PARAMETER]: '',
        }))},
        UpdateProgress: (Data) => {dispatch(UpdateMap_LS_ACTION({
           
            Key: LS_MAP + Data.MapId,
            Data: Data,
    
           
        }))},
        PostPDFStatistic: (Data) => {dispatch(AddFileAttempt_ACTION({
           
            AddPath: Routes.AddCourseMapPDFStatistic,
            Body: Data,
    
           
        }))},
  }
}
  
export default connect(MapStateToProps, MapDispatchToProps)(PlayGeneralMap)